/* eslint-disable import/prefer-default-export */
import getQuery from '../../utilities/query';
import { card } from '../../api';
import { handleError } from '../../utilities/errorHandling';

const queryClient = getQuery();

export const GET_CARD_SPENDING_LIMITS = 'card.spending.limits';

queryClient.setQueryDefaults(GET_CARD_SPENDING_LIMITS, {
  queryFn: async ({ queryKey }) => card.monavate.spendingLimits(queryKey[1]),
  onError: (error) => {
    handleError(error);
  },
});
